import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, Divider } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import SwipeableViews from 'react-swipeable-views-react-18-fix';
import DocumentMessageComponent from './DocumentMessageComponent';
import DisplaySummary from './DisplaySummary';

const DocumentMessagesComponent = ({ documentMessages, onChange, getDocumentMessage, documentMessageActiveTab, messageTypeList }) => {
  const handleTabChange = useCallback(value => () => onChange(value), [onChange]);

  return (
    <Card id={'documentMessages'} disablePadding sx={{ mb: 2 }}>
      <Tabs value={documentMessageActiveTab} variant='fullWidth'>
        {messageTypeList.map((messageType, idx) => {
          const disabled = documentMessages.filter(x => x.messageType === messageType).length === 0;

          return (
            <Tab
              id={'documentMessages_' + getDocumentMessage(messageType)}
              key={messageType}
              onClick={handleTabChange(idx)}
              icon={<DisplaySummary messageType={messageType} documentMessages={documentMessages} disabled={disabled} />}
              disabled={disabled}
            ></Tab>
          );
        })}
      </Tabs>
      {documentMessageActiveTab !== false && <Divider sx={{ m: 0 }} />}
      {typeof documentMessageActiveTab === 'number' && (
        <SwipeableViews index={documentMessageActiveTab} onChangeIndex={onChange}>
          {messageTypeList.map((messageType, index) => (
            <DocumentMessageComponent
              documentMessages={documentMessages}
              key={messageType}
              documentMessageActiveTab={documentMessageActiveTab}
              index={index}
              messageType={messageType}
              getDocumentMessage={getDocumentMessage}
            />
          ))}
        </SwipeableViews>
      )}
    </Card>
  );
};

DocumentMessagesComponent.propTypes = {
  documentMessages: PropTypes.array,
  onChange: PropTypes.func,
  getUserMessage: PropTypes.func,
  documentMessageActiveTab: PropTypes.any.isRequired,
  messageTypeList: PropTypes.array,
  getDocumentMessage: PropTypes.func
};

export default DocumentMessagesComponent;
